/*
 * @Author: Risker-C
 * @Date: 2021-09-13 16:28:00
 * @LastEditTime: 2021-09-13 17:21:53
 * @LastEditors: Risker-C
 * @Description: 
 * @FilePath: \yh-wms\src\views\content\video\view\PageHeader.tsx
 */
import { YhPageHeader } from "@/components/YhPageHeader";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import React from "react";
import { useVideoModel } from "../videoModel";

const searchFields = [
    {
        type: SearchTypeEnum.Input,
        placeholder: "文章标题",
        fieldName: "code"
    },
    {
        type: SearchTypeEnum.Input,
        placeholder: "创建人",
        fieldName: "createUser"
    },
    {
        type: SearchTypeEnum.Datepicker,
        fieldName: "createTime",
        placeholder: "创建时间",
        format: "YYYY-MM-DD",
    },
]

export function PageHeader() {
    const {
        searchParam,
        initPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useVideoModel();

    return (
        <YhPageHeader
            title="内容管理/视频新闻"
            justify="end"
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            // handleSearch={loadData}
            handleSearch={(params) => loadData(initPgCfg, params)}
            handleReset={resetSearchParam}
        />
    );
}